import React, { ReactNode } from "react";
import { Tooltip } from "antd";

export interface ChartSegment {
  key: string;
  percentage: number;
  color: string;
  label: string;
  count: number;
}

interface CircularProgressChartProps {
  segments: ChartSegment[];
  centerContent: ReactNode;
  size?: number;
  strokeWidth?: number;
}

export const CircularProgressChart: React.FC<CircularProgressChartProps> = ({
  segments,
  centerContent,
  size = 240,
  strokeWidth = 32,
}) => {
  const center = size / 2;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  let cumulativePercentage = 0;

  return (
    <div style={{ position: "relative", width: size, height: size }}>
      <svg width={size} height={size}>
        {/* Background circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="#f0f0f0"
          strokeWidth={strokeWidth}
        />
        {/* Multi-segment progress circles */}
        {segments.map((segment, index) => {
          const segmentLength = (segment.percentage / 100) * circumference;
          const segmentOffset =
            circumference - (cumulativePercentage * circumference) / 100;
          cumulativePercentage += segment.percentage;

          return (
            <Tooltip
              key={index}
              title={
                <div>
                  <div style={{ fontWeight: "bold", marginBottom: 4 }}>
                    {segment.label}
                  </div>
                  <div>Count: {segment.count}</div>
                  <div>Percentage: {segment.percentage.toFixed(1)}%</div>
                </div>
              }
              placement="top"
            >
              <circle
                cx={center}
                cy={center}
                r={radius}
                fill="none"
                stroke={segment.color}
                strokeWidth={strokeWidth}
                strokeDasharray={`${segmentLength} ${
                  circumference - segmentLength
                }`}
                strokeDashoffset={segmentOffset}
                strokeLinecap="butt"
                transform={`rotate(-90 ${center} ${center})`}
                style={{ cursor: "default" }}
              />
            </Tooltip>
          );
        })}
      </svg>
      {/* Center content */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
        }}
      >
        {centerContent}
      </div>
    </div>
  );
};
